"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveAuthTokenFromContext = exports.setAuthTokenToContext = exports.setAuthToken = exports.clearAuthToken = exports.getTokenFromCookies = void 0;
const cookies_1 = require("./cookies");
const getTokenFromCookies = (ctx, key = "token") => {
    return (0, cookies_1.getCookie)(key, ctx !== null && ctx !== void 0 ? ctx : {});
};
exports.getTokenFromCookies = getTokenFromCookies;
const clearAuthToken = (key = "token") => {
    (0, cookies_1.destroyCookie)(key, {});
    (0, cookies_1.eraseCookieFromAllPaths)(key);
};
exports.clearAuthToken = clearAuthToken;
const setAuthToken = (token, key = "token", days = 30) => {
    (0, cookies_1.setCookie)(key, token, {}, days);
};
exports.setAuthToken = setAuthToken;
const setAuthTokenToContext = (ctx, token, key = "token", days = 30) => {
    (0, cookies_1.setCookie)(key, token, ctx, days);
};
exports.setAuthTokenToContext = setAuthTokenToContext;
const retrieveAuthTokenFromContext = (ctx, key = "token") => {
    const inAppContext = Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.ctx);
    if (inAppContext) {
        return (0, exports.getTokenFromCookies)(ctx.ctx, key);
    }
    return (0, exports.getTokenFromCookies)(ctx, key);
};
exports.retrieveAuthTokenFromContext = retrieveAuthTokenFromContext;
//# sourceMappingURL=token.js.map